module.exports = __webpack_public_path__ + "media/fence_receiced.1b8856ff.wav";